import React, { Fragment } from "react";
import UF_CONTENT from "../../../../nix_components/components/UF_Content";
import withRouter from "../../../../nix_components/components/withRouter";
import data_types from "../../../../nix_components/data/data_types";
import { IconButton, Tooltip } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import NX_Form_Dialog from "../../../../nix_components/components/form_wrappers/nx_form_dialog";

class ReferralRegistrations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permission: "registration",
      scopeCondition: false,
      loaded: false,
      editRegistration: null,
    };
  }

  buttons = {
    viewRegistration: (params) => {
      return (
        <Tooltip title="View Registration">
          <IconButton
            color="primary"
            onClick={() => this.handleViewRegistration(params.row.registration_id)}
          >
            <OpenInNewIcon />
          </IconButton>
        </Tooltip>
      );
    },
  };

  formConfig = {
    rows: [
      [
        {
          label: "Registration ID",
          datatype: data_types.string,
          field: "registration_id",
        },
        {
          label: "Campaign Source",
          datatype: data_types.string,
          field: "campaign_source",
        },
      ],
      [
        {
          label: "Campaign Medium",
          datatype: data_types.string,
          field: "campaign_medium",
        },
        {
          label: "Campaign Name",
          datatype: data_types.string,
          field: "campaign_name",
        },
      ],
    ],
  };

  gridProps = {
    fields: [
      "registration_id",
      "campaign_source",
      "campaign_medium",
      "campaign_name",
      "created_at",
    ],
  };

  handleBeforeAddNew = (dataItem, callback) => {
    dataItem.event_id = global.UF.event_id;
    if (callback) {
      callback();
    }
  };

  handleViewRegistration = async (registration_id) => {
    try {
      const registrations = await global.UF.dataProvider.get_v2("registrations", {
        id: registration_id,
      });
      if (registrations && registrations.length > 0) {
        this.setState({ editRegistration: registrations[0] });
      } else {
        global.UF.setAlertVisibility(true, "Registration not found", "error");
      }
    } catch (error) {
      console.error("Error fetching registration:", error);
      global.UF.setAlertVisibility(
        true,
        "Error loading registration",
        "error"
      );
    }
  };

  onRegistrationDialogClose = () => {
    this.setState({ editRegistration: null });
  };

  findCurrentPermission = () => {
    const user =
      typeof localStorage.getItem("user") === "string"
        ? JSON.parse(localStorage.getItem("user"))
        : localStorage.getItem("user");
    const scopes = user.hasOwnProperty("scopes")
      ? typeof user.scopes === "string"
        ? JSON.parse(user.scopes)
        : user.scopes
      : null;
    this.state.scopeCondition =
      scopes.findIndex(
        (permission) =>
          permission.split(":")[0] === this.state.permission &&
          permission.includes("write")
      ) > -1;
    this.setState({ loaded: true });
  };

  componentDidMount() {
    this.findCurrentPermission();
  }

  render() {
    return (
      <Fragment>
        {this.state.editRegistration && (
          <NX_Form_Dialog
            table="registrations"
            editItem={this.state.editRegistration}
            onDialogClose={this.onRegistrationDialogClose}
            readOnly={true}
            config={{
              rows: [
                ["first_name", "last_name", "email"],
                ["company", "phone", "status"],
                [
                  {
                    field: "package_id",
                    label: "Package",
                    datatype: data_types.reference,
                    reference: "packages",
                  },
                  {
                    field: "ticket_quantity",
                    label: "Tickets",
                  },
                  {},
                ],
                [
                  {
                    field: "notes",
                    label: "Notes",
                    datatype: data_types.string,
                    multiline: true,
                  },
                ],
              ],
            }}
          />
        )}
        <UF_CONTENT
          table="refferal_registrations"
          id={this.props.event_id}
          title="Referral Program"
          permission={"registration"}
          buttons={this.buttons}
          export={this.state.scopeCondition}
          formConfig={this.formConfig}
          gridProps={this.gridProps}
          edit={this.state.scopeCondition}
          delete={this.state.scopeCondition}
          add={this.state.scopeCondition}
          beforeAddNew={this.handleBeforeAddNew}
        />
      </Fragment>
    );
  }
}

export default withRouter(ReferralRegistrations);
